import { jsx } from "react/jsx-runtime";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { DSSingleComboBox } from "@elliemae/ds-form-single-combobox";
import { Grid } from "@elliemae/ds-grid";
import { useMemo, useEffect } from "react";
import { useFormState, useWatch } from "react-hook-form";
import _ from "lodash";
import { useSingleComboboxFieldUpdateLogic } from "../utils/fieldUpdateLogic";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
import { useLoanDataFieldSelectorHook } from "../utils/utils";
import { useComboboxOptions } from "../utils/useComboboxOptions";
const DocumentationType = ({
  renderedField,
  schemaForm,
  rules,
  id,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  options,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  preview
}) => {
  const singleComboboxFieldUpdateLogic = useSingleComboboxFieldUpdateLogic();
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const selfEmployed = useLoanDataFieldSelectorHook(
    "loanInformation.selfEmployedBorrower"
  );
  let valueAsString = "";
  const watchedFieldValue = useWatch({
    control: schemaForm.control,
    name: pathValue
  });
  const { allOptionsTransformed, visibleOptions: allComboboxOptions } = useComboboxOptions({
    options,
    schemaForm,
    rules,
    preview
  });
  const getEmploymentValue = (val) => {
    if (name === "Employment") {
      if (val === "100") {
        if (selfEmployed.value === true) return "2";
        return "1";
      }
    }
    return val;
  };
  const selectedOption = useMemo(() => {
    valueAsString = String(getEmploymentValue(watchedFieldValue) ?? "");
    return allOptionsTransformed.find((option) => option.value === valueAsString) || null;
  }, [allOptionsTransformed, watchedFieldValue]);
  useEffect(() => {
    valueAsString = String(getEmploymentValue(watchedFieldValue) ?? "");
    schemaForm.setValue(pathValue, valueAsString);
  }, [watchedFieldValue]);
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, style: { display: isVisible ? "block" : "none" }, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      inputID: name,
      required,
      feedbackMessage,
      hasError: !!errors[id] || !!errorMessage,
      validationMessage: errors[id]?.message?.toString() || errorMessage,
      children: /* @__PURE__ */ jsx(
        DSSingleComboBox,
        {
          ...renderedField,
          allOptions: allComboboxOptions,
          onChange: singleComboboxFieldUpdateLogic(
            renderedField,
            schemaForm,
            id
          ),
          selectedValue: selectedOption,
          id: pathValue,
          disabled: isDisabled,
          isNonClearable: true
        }
      )
    }
  ) });
};
export {
  DocumentationType
};
